<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <div class="outerLayer">
      <div class="content">
        <div class="titleContent flex">
          <img src="@/assets/blueScience/title_lf.png" alt="" class="imgBase">
          <span :style="{'color':info.setting.color}">搜索</span>
          <img src="@/assets/blueScience/title_rg.png" alt="" class="imgBase">
        </div>
        <div class="input">
          <van-search clearable @clear='clear()' v-model="value" placeholder="请输入选手编号或名称" />
        </div>
        <div class="searchBtn">
          <van-button :style="{'background':info.setting.color}" @click="gotoVote()" type="primary">搜索</van-button>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close">
      <van-icon @click='close()' name="close" />
    </div>
  </div>
</template>

<script>
import searchMixin from '@/mixins/search.js'
export default {
  mixins: [searchMixin],
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem('info'))
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  div.outerLayer {
    background: #4079fa;
    border-radius: 0.1067rem;
    overflow: hidden;
    width: 90%;
    div.content {
      background: #f6f8ff;
      border-radius: 4px;
      margin: 0.1067rem;
      overflow: hidden;
      .titleContent {
        font-size: 0;
        text-align: center;
        height: 1.6rem;
        span {
          font-size: 0.4267rem;
          margin: 0 0.2667rem;
        }
      }
      .input {
        margin: 0.8rem 0 0.8rem;
        .van-search {
          background: #ffe1af;
          border: 0.02rem solid #ccc;
          padding: 0;
          margin: 0 0.2666667rem;
        }
      }
      .searchBtn {
        height: 0.96rem;
        width: 2.6667rem;
        box-sizing: border-box;
        margin: 0.5333rem auto;
        .van-button {
          width: 100%;
          height: 100%;
          border-radius: 0.1067rem;
          color: #fff;
          background: #ffcc86;
          border: none;
        }
      }
    }
  }
  div.close {
    margin-top: 0.5333333rem;
    .van-icon-close {
      font-size: 0.96rem;
      color: #fff;
    }
  }
}
</style>